/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CarrierDocumentDataFromHubble,
  CarrierDocuments,
  DocumentDownloadResponse,
  ImageResponse,
} from "../models/index";
import {
  CarrierDocumentDataFromHubbleFromJSON,
  CarrierDocumentDataFromHubbleToJSON,
  CarrierDocumentsFromJSON,
  CarrierDocumentsToJSON,
  DocumentDownloadResponseFromJSON,
  DocumentDownloadResponseToJSON,
  ImageResponseFromJSON,
  ImageResponseToJSON,
} from "../models/index";

export interface DeleteCarrierDocumentRequest {
  carrierDocumentId: string;
}

export interface DownloadByReferenceNumberRequest {
  referenceNumber: string;
}

export interface DownloadCarrierDocumentByS3PathRequest {
  s3Key: string;
  contentType?: string | null;
}

export interface DownloadThumbnailByThumbnailS3KeyRequest {
  thumbnailKey: string;
}

export interface ExtractCarrierDocumentFromExistingDocumentRequest {
  s3Key: string;
  pages: Array<number>;
  carrierDocumentDataFromHubble: CarrierDocumentDataFromHubble;
}

export interface GetByReferenceNumberRequest {
  referenceNumber: string;
}

export interface GetDocumentsForCarrierRequest {
  carrierIdentifier: string;
  current?: boolean | null;
}

export interface InsertCarrierDocumentsRequest {
  carrierDocumentDataFromHubble: Array<CarrierDocumentDataFromHubble>;
}

export interface RegenerateReferenceNumberRequest {
  carrierDocumentId: string;
}

export interface UpdateCarrierDocumentMetadataRequest {
  carrierDocumentId: string;
  carrierDocumentDataFromHubble: CarrierDocumentDataFromHubble;
}

/**
 *
 */
export class CarrierDocumentsApi extends runtime.BaseAPI {
  /**
   */
  async deleteCarrierDocumentRaw(
    requestParameters: DeleteCarrierDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierDocumentId"] == null) {
      throw new runtime.RequiredError(
        "carrierDocumentId",
        'Required parameter "carrierDocumentId" was null or undefined when calling deleteCarrierDocument().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierDocumentId"] != null) {
      queryParameters["carrierDocumentId"] =
        requestParameters["carrierDocumentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-documents/delete-document`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteCarrierDocument(
    requestParameters: DeleteCarrierDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteCarrierDocumentRaw(requestParameters, initOverrides);
  }

  /**
   */
  async downloadByReferenceNumberRaw(
    requestParameters: DownloadByReferenceNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DocumentDownloadResponse>> {
    if (requestParameters["referenceNumber"] == null) {
      throw new runtime.RequiredError(
        "referenceNumber",
        'Required parameter "referenceNumber" was null or undefined when calling downloadByReferenceNumber().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["referenceNumber"] != null) {
      queryParameters["referenceNumber"] = requestParameters["referenceNumber"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-documents/download-by-reference-number`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DocumentDownloadResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async downloadByReferenceNumber(
    requestParameters: DownloadByReferenceNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DocumentDownloadResponse> {
    const response = await this.downloadByReferenceNumberRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async downloadCarrierDocumentByS3PathRaw(
    requestParameters: DownloadCarrierDocumentByS3PathRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<DocumentDownloadResponse>> {
    if (requestParameters["s3Key"] == null) {
      throw new runtime.RequiredError(
        "s3Key",
        'Required parameter "s3Key" was null or undefined when calling downloadCarrierDocumentByS3Path().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["s3Key"] != null) {
      queryParameters["s3Key"] = requestParameters["s3Key"];
    }

    if (requestParameters["contentType"] != null) {
      queryParameters["contentType"] = requestParameters["contentType"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-documents/download-document`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      DocumentDownloadResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async downloadCarrierDocumentByS3Path(
    requestParameters: DownloadCarrierDocumentByS3PathRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<DocumentDownloadResponse> {
    const response = await this.downloadCarrierDocumentByS3PathRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async downloadThumbnailByThumbnailS3KeyRaw(
    requestParameters: DownloadThumbnailByThumbnailS3KeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ImageResponse>> {
    if (requestParameters["thumbnailKey"] == null) {
      throw new runtime.RequiredError(
        "thumbnailKey",
        'Required parameter "thumbnailKey" was null or undefined when calling downloadThumbnailByThumbnailS3Key().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["thumbnailKey"] != null) {
      queryParameters["thumbnailKey"] = requestParameters["thumbnailKey"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-documents/download-thumbnails`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ImageResponseFromJSON(jsonValue),
    );
  }

  /**
   */
  async downloadThumbnailByThumbnailS3Key(
    requestParameters: DownloadThumbnailByThumbnailS3KeyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ImageResponse> {
    const response = await this.downloadThumbnailByThumbnailS3KeyRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async extractCarrierDocumentFromExistingDocumentRaw(
    requestParameters: ExtractCarrierDocumentFromExistingDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["s3Key"] == null) {
      throw new runtime.RequiredError(
        "s3Key",
        'Required parameter "s3Key" was null or undefined when calling extractCarrierDocumentFromExistingDocument().',
      );
    }

    if (requestParameters["pages"] == null) {
      throw new runtime.RequiredError(
        "pages",
        'Required parameter "pages" was null or undefined when calling extractCarrierDocumentFromExistingDocument().',
      );
    }

    if (requestParameters["carrierDocumentDataFromHubble"] == null) {
      throw new runtime.RequiredError(
        "carrierDocumentDataFromHubble",
        'Required parameter "carrierDocumentDataFromHubble" was null or undefined when calling extractCarrierDocumentFromExistingDocument().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["s3Key"] != null) {
      queryParameters["s3Key"] = requestParameters["s3Key"];
    }

    if (requestParameters["pages"] != null) {
      queryParameters["pages"] = requestParameters["pages"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-documents/extract-from-existing-document`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CarrierDocumentDataFromHubbleToJSON(
          requestParameters["carrierDocumentDataFromHubble"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async extractCarrierDocumentFromExistingDocument(
    requestParameters: ExtractCarrierDocumentFromExistingDocumentRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.extractCarrierDocumentFromExistingDocumentRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async getByReferenceNumberRaw(
    requestParameters: GetByReferenceNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierDocuments>> {
    if (requestParameters["referenceNumber"] == null) {
      throw new runtime.RequiredError(
        "referenceNumber",
        'Required parameter "referenceNumber" was null or undefined when calling getByReferenceNumber().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["referenceNumber"] != null) {
      queryParameters["referenceNumber"] = requestParameters["referenceNumber"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-documents/get-by-reference-number`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierDocumentsFromJSON(jsonValue),
    );
  }

  /**
   */
  async getByReferenceNumber(
    requestParameters: GetByReferenceNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierDocuments> {
    const response = await this.getByReferenceNumberRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getDocumentsForCarrierRaw(
    requestParameters: GetDocumentsForCarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierDocuments>>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling getDocumentsForCarrier().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    if (requestParameters["current"] != null) {
      queryParameters["current"] = requestParameters["current"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-documents`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierDocumentsFromJSON),
    );
  }

  /**
   */
  async getDocumentsForCarrier(
    requestParameters: GetDocumentsForCarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierDocuments>> {
    const response = await this.getDocumentsForCarrierRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async insertCarrierDocumentsRaw(
    requestParameters: InsertCarrierDocumentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierDocumentDataFromHubble"] == null) {
      throw new runtime.RequiredError(
        "carrierDocumentDataFromHubble",
        'Required parameter "carrierDocumentDataFromHubble" was null or undefined when calling insertCarrierDocuments().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-documents/insert-documents`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters["carrierDocumentDataFromHubble"]!.map(
          CarrierDocumentDataFromHubbleToJSON,
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async insertCarrierDocuments(
    requestParameters: InsertCarrierDocumentsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.insertCarrierDocumentsRaw(requestParameters, initOverrides);
  }

  /**
   */
  async regenerateReferenceNumberRaw(
    requestParameters: RegenerateReferenceNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierDocumentId"] == null) {
      throw new runtime.RequiredError(
        "carrierDocumentId",
        'Required parameter "carrierDocumentId" was null or undefined when calling regenerateReferenceNumber().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierDocumentId"] != null) {
      queryParameters["carrierDocumentId"] =
        requestParameters["carrierDocumentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-documents/regenerate-reference-number`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async regenerateReferenceNumber(
    requestParameters: RegenerateReferenceNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.regenerateReferenceNumberRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateCarrierDocumentMetadataRaw(
    requestParameters: UpdateCarrierDocumentMetadataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierDocumentId"] == null) {
      throw new runtime.RequiredError(
        "carrierDocumentId",
        'Required parameter "carrierDocumentId" was null or undefined when calling updateCarrierDocumentMetadata().',
      );
    }

    if (requestParameters["carrierDocumentDataFromHubble"] == null) {
      throw new runtime.RequiredError(
        "carrierDocumentDataFromHubble",
        'Required parameter "carrierDocumentDataFromHubble" was null or undefined when calling updateCarrierDocumentMetadata().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierDocumentId"] != null) {
      queryParameters["carrierDocumentId"] =
        requestParameters["carrierDocumentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-documents/update-document-metadata`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CarrierDocumentDataFromHubbleToJSON(
          requestParameters["carrierDocumentDataFromHubble"],
        ),
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateCarrierDocumentMetadata(
    requestParameters: UpdateCarrierDocumentMetadataRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateCarrierDocumentMetadataRaw(
      requestParameters,
      initOverrides,
    );
  }
}
